<div class="wrapper">

  <section id="lista-hoteis" style="padding-top: 25px;">
    <div class="container is-fluid">
      <nav class="breadcrumb">
        <ul>
          <li><a href="/"><strong>Início</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li><a href="/"><strong>Hotéis</strong></a></li>
          <span><i class="fas fa-chevron-right"></i></span>
          <li> Ponta dos Ganhos Resort</li>
        </ul>
      </nav>

      <div class="columns">
        <div class="column is-3" id="montreal-hotel-busca">
          <form class="sample-form" method="post" action-xhr="/documentation/examples/api/submit-form-xhr"
            target="_top">
            <h4>Filtrar</h4>
            <p>Remover filtros aplicados</p>
            <p><strong>PLANO</strong></p>

            <label for="conforto" class="area-check">
              Conforto
              <input type="radio" id="conforto" name="Plano" value="conforto" checked>
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="tranquilidade" class="area-check">
              Tranquilidade
              <input type="radio" id="tranquilidade" name="Plano" value="tranquilidade">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <p><strong>TIPO DE HOTEL</strong></p>

            <label for="hotel" class="area-check">
              Hotel
              <input type="radio" id="hotel" name="Tipo de Hotel" value="Hotel" checked>
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="resort" class="area-check">
              Resort
              <input type="radio" id="resort" name="Tipo de Hotel" value="Resort">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <p><strong>TIPO DE QUARTO</strong></p>

            <label for="duplo" class="area-check">
              Duplo
              <input type="radio" id="duplo" name="Tipo de Quarto" value="Duplo" checked>
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="triplo" class="area-check">
              Triplo
              <input type="radio" id="triplo" name="Tipo de Quarto" value="Triplo">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <p><strong>TIPO DE CAMA</strong></p>

            <label for="solteiro" class="area-check">
              Solteiro
              <input type="radio" id="solteiro" name="Tipo de Cama" value="Solteiro" checked>
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="casal" class="area-check">
              Casal
              <input type="radio" id="casal" name="Tipo de Cama" value="casal">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="queen" class="area-check">
              Queen
              <input type="radio" id="queen" name="Tipo de Cama" value="queen">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="king" class="area-check">
              King
              <input type="radio" id="king" name="Tipo de Cama" value="king">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <p><strong>COMODIDADES</strong></p>

            <label for="wifi" class="area-check">
              Wi-fi
              <input type="checkbox" id="wifi" name="Comodidades" value="wifi" checked>
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="ar-condicionado" class="area-check">
              Ar condicionado
              <input type="checkbox" id="ar-condicionado" name="Comodidades" value="ar-condicionado">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="piscina" class="area-check">
              Piscina
              <input type="checkbox" id="piscina" name="Comodidades" value="piscina">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="sauna" class="area-check">
              Sauna
              <input type="checkbox" id="sauna" name="Comodidades" value="sauna">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <p><strong>REGIME DE ALIMENTAÇÃO</strong></p>

            <label for="all-inclusive" class="area-check">
              All-Inclusive
              <input type="radio" id="all-inclusive" name="Regime de alimentação" value="all-inclusive" checked>
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="meia-pensao" class="area-check">
              Meia pensão
              <input type="radio" id="meia-pensao" name="Regime de alimentação" value="meia-pensao">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="cafe-da-manha" class="area-check">
              Café da manhã
              <input type="radio" id="cafe-da-manha" name="Regime de alimentação" value="cafe-da-manha">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <p><strong>EXTRAS</strong></p>

            <label for="pet-friendly" class="area-check">
              Pet friendly
              <input type="checkbox" id="pet-friendly" name="EXTRAS" value="pet-friendly" checked>
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

            <label for="acessivel-cadeirantes" class="area-check">
              Acessível cadeirantes
              <input type="checkbox" id="acessivel-cadeirantes" name="EXTRAS" value="acessivel-cadeirantes">
              <span class="checkmark"><i class="fas fa-check"></i></span>
            </label>

          </form>

        </div>
        <div class="column is-9">
          <div class="columns">
            <div class="column is-9">
              <div class="result-message">
                Resultados para Governador Celso Ramos <strong class="count-result">132 Hotéis</strong>
              </div>
            </div>
            <div class="column is-3">
              Ordernar por:
            </div>
          </div>
          <div class="item-hotel-list">
            <div class="item-hotel small-hotel">
              <a href="">
                <figure>
                  <img class="bg-hotel" src="assets/img/img-hotel.png" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>Ponta dos Ganchos Resort</h3>
                      <p>Governardor Celso Ramos, SC</p>
                      <a href="#" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <div class="column is-5 has-text-right">
                      <p class="tag">Tranquilidade</p>
                      <p>Não pague <del>R$ 1.480,00</del> na diária</p>
                      <a href="#" class="btn btn-primary"><i class="fa fa-user"></i> Reserve no Portal do Cliente</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div class="item-hotel small-hotel">
              <a href="">
                <figure>
                  <img class="bg-hotel" src="assets/img/img-hotel.png" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>Ponta dos Ganchos Resort</h3>
                      <p>Governardor Celso Ramos, SC</p>
                      <a href="#" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <div class="column is-5 has-text-right">
                      <p class="tag">Tranquilidade</p>
                      <p>Não pague <del>R$ 1.480,00</del> na diária</p>
                      <a href="#" class="btn btn-primary"><i class="fa fa-user"></i> Reserve no Portal do Cliente</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div class="item-hotel small-hotel">
              <a href="">
                <figure>
                  <img class="bg-hotel" src="assets/img/img-hotel.png" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>Ponta dos Ganchos Resort</h3>
                      <p>Governardor Celso Ramos, SC</p>
                      <a href="#" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <div class="column is-5 has-text-right">
                      <p class="tag">Tranquilidade</p>
                      <p>Não pague <del>R$ 1.480,00</del> na diária</p>
                      <a href="#" class="btn btn-primary"><i class="fa fa-user"></i> Reserve no Portal do Cliente</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div class="item-hotel small-hotel">
              <a href="">
                <figure>
                  <img class="bg-hotel" src="assets/img/img-hotel.png" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>Ponta dos Ganchos Resort</h3>
                      <p>Governardor Celso Ramos, SC</p>
                      <a href="#" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <div class="column is-5 has-text-right">
                      <p class="tag">Tranquilidade</p>
                      <p>Não pague <del>R$ 1.480,00</del> na diária</p>
                      <a href="#" class="btn btn-primary"><i class="fa fa-user"></i> Reserve no Portal do Cliente</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div class="item-hotel small-hotel">
              <a href="">
                <figure>
                  <img class="bg-hotel" src="assets/img/img-hotel.png" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>Ponta dos Ganchos Resort</h3>
                      <p>Governardor Celso Ramos, SC</p>
                      <a href="#" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <div class="column is-5 has-text-right">
                      <p class="tag">Tranquilidade</p>
                      <p>Não pague <del>R$ 1.480,00</del> na diária</p>
                      <a href="#" class="btn btn-primary"><i class="fa fa-user"></i> Reserve no Portal do Cliente</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div class="item-hotel small-hotel">
              <a href="">
                <figure>
                  <img class="bg-hotel" src="assets/img/img-hotel.png" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>Ponta dos Ganchos Resort</h3>
                      <p>Governardor Celso Ramos, SC</p>
                      <a href="#" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <div class="column is-5 has-text-right">
                      <p class="tag">Tranquilidade</p>
                      <p>Não pague <del>R$ 1.480,00</del> na diária</p>
                      <a href="#" class="btn btn-primary"><i class="fa fa-user"></i> Reserve no Portal do Cliente</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div class="item-hotel small-hotel">
              <a href="">
                <figure>
                  <img class="bg-hotel" src="assets/img/img-hotel.png" />
                </figure>
                <div class="footer-hotel">
                  <div class="columns">
                    <div class="column is-7">
                      <h3>Ponta dos Ganchos Resort</h3>
                      <p>Governardor Celso Ramos, SC</p>
                      <a href="#" class="link-detalhes">Ver detalhes</a>
                    </div>
                    <div class="column is-5 has-text-right">
                      <p class="tag">Tranquilidade</p>
                      <p>Não pague <del>R$ 1.480,00</del> na diária</p>
                      <a href="#" class="btn btn-primary"><i class="fa fa-user"></i> Reserve no Portal do Cliente</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
  <app-tabela-diarias></app-tabela-diarias>
  <app-footer></app-footer>
</div>
